import React, { useState, useEffect, useRef } from "react";

import { Dialog } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "../../../UniversalComponents/SelectComponent";
import { ReactComponent as DownAngelBracket } from "../../../../assets/images/downAngleBracket.svg";
import { useFetchAllCompnayGroupQuery } from "../../../../utils/customer/customerListHeader";
import {
  getCompanyId,
  getIsOwner,
  getOrganizationId,
  getUserId,
  getUserToken,
} from "../../../../utils/utilityFunctions/localServices";
import Button from "../../../UniversalComponents/DefaultButton";
import InputComponent from "../../../UniversalComponents/InputComponent";

const CreateViewDialog = ({
  goBack,
  groupIds,
  setGroupIds,
  handleCreateView,
  isEditView,
  assignRole,
  setAssignRole,
}) => {
  const [newView, setNewView] = useState(isEditView ? isEditView : "");
  // const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const handleNamechange = (event) => {
    if (event.target.value.length < 20) setNewView(event.target.value);
  };

  const [isError, setIsError] = useState(false);

  const handleSelectChangeAssign = (e) => {
    setSelectedValue(e.target.value);
    setGroupIds(e.target.value);
  };

  const {
    data: groupData,
    refetch,
    isLoading,
  } = useFetchAllCompnayGroupQuery({
    token: getUserToken(),
    params: {
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      // user_id: getUserId(),
      fetch_user_group: true,
    },
  });

  console.log(
    "groupData op",
    groupData?.data?.filter((item) => groupIds.includes(item.group_id))
  );

  const handleAddNewViewSubmit = () => {
    if ((newView && !assignRole) || (newView && assignRole && groupIds?.length > 0)) {
      handleCreateView(newView);
      goBack();
    } else {
      setIsError(true);
    }
  };

  return (
    <div className="h-full flex flex-col justify-between">
      <div>
        <div className="border-b-2 ">
          <div className="flex items-center justify-start gap-1 p-3">
            <i className="bi bi-arrow-left cursor-pointer" onClick={goBack}></i>
            <h3 className="text-434852 font-medium text-base">{isEditView ? "Edit View" : "Create View"}</h3>
          </div>
        </div>

        <div className="m-4">
          <label for="name" class="block text-434852 text-14 font-normal mb-2">
            View Name
          </label>
          <InputComponent
            type="text"
            id="name"
            name="name"
            // class="shadow appearance-none border border-DFE2E5 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none  focus:ring-0"
            placeholder="Enter Details"
            value={newView}
            onChange={handleNamechange}
            error={isError}
            mandatory
          />
        </div>
        {getIsOwner() && (
          <div className="m-4 space-x-1">
            <input
              type="checkbox"
              className="appearance-none  text-12 disabled:cursor-not-allowed focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
              style={{ boxShadow: "none" }}
              onChange={() => setAssignRole(!assignRole)}
              disabled={Boolean(isEditView)}
              checked={assignRole}
            />
            <label className="text-434852 text-12 font-normal">Assign To Role</label>
          </div>
        )}
        {getIsOwner() && (
          <div className="m-4">
            <label for="name" class="block text-434852 text-14 font-normal mb-2">
              Groups
            </label>
            <Select
              name="assigntoselect"
              options={groupData?.data?.map((item) => ({ value: item.group_id, label: item.group_name }))}
              placeholder="Select Group to Assign"
              // selectedOptions={groupData?.data
              //   ?.filter((item) => groupIds.includes(item.group_id))
              //   .map((item) => ({ value: item.group_id, label: item.group_name }))}
              value={groupData?.data
                ?.filter((item) => groupIds.includes(item.group_id))
                .map((item) => ({ value: item.group_id, label: item.group_name }))}
              multiSelect
              onChange={handleSelectChangeAssign}
              disabled={!assignRole}
              style={{ width: "100%", height: "35px", padding: "5px", boxSizing: "border-box" }}
              isError={isError}
              // endAdornment={<DownArrow fill={`#1D4469`} className={`${true ? "rotate-180 " : "rotate-0"} transition-all duration-300`} />}
            ></Select>
          </div>
        )}
      </div>
      <div className="border-t-2 align-bottom">
        <div className="flex justify-end space-x-4 m-5">
          <Button
            variant={"primary"}
            onClick={() => {
              handleAddNewViewSubmit();
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateViewDialog;
